import React from 'react';
import { Link } from 'react-router-dom';
import { useCategories, STATIC_CATEGORIES } from '../../shared/hooks/useCategories.js';

export default function CategorySearch({ categories = [] }) {
  const { categories: apiCategories, loading: loading, error: error } = useCategories();

  const items = React.useMemo(() => {
    // Prefer provided prop
    if (Array.isArray(categories) && categories.length > 0) {
      return categories.map((c, i) => {
        if (typeof c === 'string') return { id: undefined, name: c };
        if (c && typeof c === 'object') {
          return {
            id: c.id ?? c.category_id ?? c.value,
            name: c.name ?? c.title ?? c.label ?? `Catégorie ${i + 1}`,
          };
        }
        return { id: undefined, name: `Catégorie ${i + 1}` };
      });
    }
    // Else use hook data with static fallback
    const data = (apiCategories && apiCategories.length)
      ? apiCategories
      : STATIC_CATEGORIES.map((n) => ({ id: undefined, name: n }));
    return data;
  }, [categories, apiCategories]);

  const cols = 3;
  const perCol = Math.ceil(items.length / cols);
  const split = Array.from({ length: cols }, (_, i) => items.slice(i * perCol, (i + 1) * perCol));

  return (
    <section className="mt-3 mt-md-4">
      <div className="card border-0 shadow-sm rounded-4">
        <div className="card-header bg-white border-0 py-3 px-3 px-md-4 d-flex align-items-center justify-content-between">
          <h5 className="mb-0">
            Recherche par <span className="fw-semibold">Catégorie</span>
          </h5>
          <Link to="/posts" className="small text-success text-decoration-none fw-semibold">
            VOIR PLUS <i className="fa-solid fa-bars ms-1"></i>
          </Link>
        </div>
        <div className="card-body pt-0 px-3 px-md-4 pb-3 pb-md-4">
          {loading && (
            <div className="text-muted py-2">Chargement des catégories…</div>
          )}
          {error && !loading && (
            <div className="text-danger py-2">{error}</div>
          )}
          <div className="row">
            {split.map((col, idx) => (
              <div className="col-12 col-md-6 col-lg-4" key={idx}>
                <ul className="list-unstyled mb-0">
                  {col.map((it) => (
                    <li key={it.id ?? it.name} className="py-2">
                      <Link
                        to={`/posts?${it.id ? `category_id=${encodeURIComponent(it.id)}` : `category=${encodeURIComponent(it.name)}`}`}
                        className="text-reset text-decoration-none d-flex align-items-center gap-2"
                      >
                        <i className="fa-regular fa-folder"></i>
                        <span>{it.name}</span>
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
